import React from 'react';
import styles from './HighlightCard.module.scss';
import { HighlightCardConfig } from '../../../../Models/Widget';
import { TextOverflowTooltip } from '../../../TextOverflowTooltip/TextOverflowTooltip';

export interface HighlightCardProps extends HighlightCardConfig {}

export const HighlightCard = ({
  label,
  value
}: HighlightCardProps): React.ReactElement<HighlightCardProps> => {
  const strValue = `${Math.floor(value)}`;
  return (
    <div className={styles.highlightCard}>
      <div className={styles.data}>
        <TextOverflowTooltip title={label}>
          <span className={styles.value}>{label}</span>
        </TextOverflowTooltip>

        <div className={styles.chip}>{strValue}</div>
      </div>
    </div>
  );
};
